import { Button } from '@eventbrite/eds-button';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import ConnectedImplicitToSFooterDisclaimer from '../../components/disclaimer/ConnectedImplicitToSFooterDisclaimer';
import ConnectedApplepayNativeButton from '../../components/paymentMethodForms/ApplepayNativeButton/ConnectedApplepayNativeButton';
import {
    CTA_EXPRESS_CHECKOUT_WITHOUT_APPLE_PAY,
    CTA_EXPRESS_CHECKOUT_WITH_APPLE_PAY,
} from '../../constants/index';
import { ApplePayNameSpace } from '../../state/applePay';
import './ExpressCheckout.scss';

export type ExpressCheckoutProps = {
    applePay: ApplePayNameSpace;
    applePayError?: boolean;
    handleSubmit: (props: { isApplePay: boolean }) => void;
    isSubmitting: boolean;
    keepDisabledStyleWhileLoading: boolean;
};

export const SkeletonButton = () => (
    <div className="skeleton-button" data-testid="skeleton-button">
        <span className="eds-is-hidden-accessible">
            {gettext('Loading...')}
        </span>
    </div>
);

export const ExpressCheckout: React.FC<ExpressCheckoutProps> = ({
    applePay,
    applePayError = false,
    handleSubmit,
    isSubmitting,
    keepDisabledStyleWhileLoading,
}) => {
    const { applepayInstance } = applePay;
    const isApplePayReady = applepayInstance && !applePayError;

    const primaryButtonText = !applePayError
        ? CTA_EXPRESS_CHECKOUT_WITH_APPLE_PAY
        : CTA_EXPRESS_CHECKOUT_WITHOUT_APPLE_PAY;

    return (
        <>
            {isApplePayReady && (
                <div className="eds-l-pad-bot-4 eds-fx--fade-in eds-fx--duration-2">
                    <ConnectedImplicitToSFooterDisclaimer
                        ctaText={gettext('Buy with Apple Pay')}
                    />
                </div>
            )}

            <div data-testid="express-checkout" className="eds-align--right">
                <div className="express-checkout-buttons">
                    <div className="express-checkout-single-button">
                        {isApplePayReady ? (
                            <div className="eds-fx--fade-in eds-fx--duration-2">    <ConnectedApplepayNativeButton
                                handleSubmit={handleSubmit}
                            />
                        </div>
                    ): (
                            <SkeletonButton />
                        )}
                    </div>
                    <div className="express-checkout-single-button">
                        <Button
                            onClick={handleSubmit}
                            style="fill"
                            size="block"
                            keepDisabledStyleWhileLoading={
                                keepDisabledStyleWhileLoading
                            }
                            data-spec={'eds-modal__primary-button'}
                            data-automation={'eds-modal__primary-button'}
                            isLoading={isSubmitting}
                        >
                            {primaryButtonText}
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
};
